import './banner.scss';

/**
 * version    1.0
 * class      <type> (banner)
 * classdesc  Component that manage the page banner
 */
export class Banner {}
